import styles from "./styles.module.css";
import Image from "@/shared/components/Image/new";

const Destacadas = (props) => {
	const CLIPPING = "3_2_630x420";
	const { content } = props;
	
	return (
		<div className={` ${styles["destacadas-parent"]}`}>
			{content &&
				content.map((element, id) => {
					const { url, title, subtitle } = element;

					return (
						<div className={`${styles["destacadas-container"]}`} key={element + id}>
							<div className={` ${styles["destacadas-img"]}`}>
								<a href={url}>
									<Image
										element={element}
										clipping={CLIPPING}
									/>
								</a>
							</div>
							<div className={`${styles["destacadas-txt-container"]}`}>
								<a href={url}>
									<h5>{subtitle}</h5>
									<h1>{title}</h1>
								</a>
							</div>
						</div>
					);
				})}
		</div>
	);
};
export default Destacadas;
